<template>
  <!-- eslint-disable vue/singleline-html-element-content-newline -->
  <div class="mobile-pay">
    <canvas
      id="mobilePay"
      width="164"
      height="164"
    />
    <div
      class="action-box"
      v-if="isMiniProgram"
    >
      <div class="label">{{ $t('order.mobileTitle') }}：</div>
      <div
        class="action-once"
        :class="{ active: type === 'once' }"
        @click="handleChoose('once')"
      >
        <i class="iconfont icon-true" />{{ $t('order.mobileTotal') }}
      </div>
      <div
        class="action-split"
        :class="{ active: type === 'split' }"
        @click="handleChoose('split')"
      >
        <div class="split-info">
          <i class="iconfont icon-true" />
          <div class="input-box">
            <div class="input-currency">￥</div>
            <input
              class="input-amount"
              v-model="splitValue"
            >
            <div class="input-unit">,000</div>
          </div>
          <button
            class="get-code"
            @click="handleRefreshCode"
            v-t="'order.refreshCode'"
          />
        </div>
        <div
          class="split-tips"
          v-t="'order.mobileTips'"
        />
      </div>
    </div>
  </div>
</template>
<script>
  import { mapState, mapGetters } from 'vuex'
  import QRCode from 'qrcode'

  const makeCode = orderId => {
    const $canvas = document.getElementById('mobilePay')
    return amount => {
      QRCode.toCanvas($canvas, `https://${window.location.host}/pay/index.html?orderId=${orderId}&amount=${amount}`)
    }
  }

  export default {
    name: 'OrderPayMobile',
    data () {
      return {
        type: 'once',
        splitValue: 1,
      }
    },
    computed: {
      ...mapState('order', {
        amount: state => state.detail.amount
      }),
      ...mapGetters('main', ['isMiniProgram']),
      orderId () {
        return this.$route.params.id
      },
    },
    created () {
      this.$nextTick(() => {
        this.makeCode = makeCode(this.orderId)
        this.makeCode(this.amount)
      })
    },
    watch: {
      type: {
        handler (val) {
          this.splitValue = 1
          if (val === 'once') {
            this.makeCode(this.amount)
          } else {
            this.makeCode(this.splitValue * 1000)
          }
        },
      },
      amount () {
        this.generateCodeImg()
      }
    },
    methods: {
      handleChoose (value) {
        this.type = value
      },
      generateCodeImg () {
        this.makeCode(this.amount)
      },
      handleRefreshCode () {
        if (this.splitValue < 1) this.splitValue = 1
        if (this.splitValue > 394) this.splitValue = 394
        this.makeCode(this.splitValue * 1000)
      }
    }
  }
</script>
<style lang="scss" scoped>
  .mobile-pay{
    display: flex;
    flex-direction: column;
    padding-top: 6px;
  }
  #mobilePay{
    width: 164px !important;
    height: 164px !important;
    margin-left: -14px;
  }
  .action-box{
    display: flex;
    align-items: flex-start;
    margin-top: 6px;
    line-height: 34px;
    color: #909090;
    .iconfont{
      margin-right: 8px;
    }
    @include layout--mobile{
      flex-direction: column;
      align-items: flex-start;
    }
  }
  .label{
    margin-right: 20px;
    &::before{
      content: '*';
      color: #E4443E;
    }
  }
  .action-once,
  .action-split{
    cursor: pointer;
    &.active{
      .icon-true{
        color: #12B56A;
      }
    }
  }
  .action-split{
    margin-left: 18px;
    @include layout--mobile{
      margin-left: 0;
    } 
  }
  .split-info{
    display: flex;
    align-items: center;
  }
  .input-box{
    position: relative;
    color: #3A444A;
  }
  .input-currency,
  .input-unit{
    position: absolute;
    top: 0;
    height: 34px;
    line-height: 34px;
  }
  .input-currency{
    left: 8px;
  }
  .input-amount{
    width: 180px;
    height: 34px;
    padding: 0 38px 0 25px;
    line-height: 34px;
    text-align: right;
    border: 1px solid #D0CDCD;
    color: inherit;
    background: #F5F5F5;
  }
  .input-unit{
    right: 8px;
  }
  .get-code{
    @extend %base-button;
    width: 88px;
    height: 34px;
    margin-left: 8px;
    line-height: 34px;
  }
  .split-tips{
    padding-left: 24px;
    font-size: 12px;
    line-height: 20px;
    color: #E4443E;
  }
</style>


